<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F1LidS/tc-custom/9781418557348.jpg?1705231658392" alt="This image is the cover for the book Arizona Trivia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arizona Trivia
      </h1>
      <p class="bookDescription body article font2">
        <b>Test your Arizona knowledge with this trivia book covering the state’s rich history, geography, sports, culture, notable figures, and more!</b><br/><br/>The last continental state to enter the Union, Arizona is a fascinating place, and <i>Arizona Trivia </i>is full of facts to prove it. This book is the ultimate resource on the who, what, where, when, and how of the Grand Canyon State. Inside, you’ll learn the answers to intriguing questions such as: “Approximately how many rounds of golf were played in Phoenix in 2000?”, “What are the deepest and widest points of the Grand Canyon?”, and many others!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James A. Crutchfield
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7060c39a